module.exports = __webpack_public_path__ + "static/media/matias_soule.6fe10a00.jpg";